import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadWebhooks: ['partner'],
  loadWebhooksSuccess: ['url'],
  resetWebhooks: [],
  saveWebhook: ['partner', 'request_url', 'is_change'],
  saveWebhookSuccess: ['partner', 'request_url'],
  loadTokens: ['partner'],
  loadTokensSuccess: ['data'],
  resetTokens: [],
  addToken: ['partner', 'name', 'description'],
  addTokenSuccess: ['data']
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  webhooks: {
    loading: true,
    url: ''
  },
  tokens: {
    loading: true,
    adding: false,
    data: []
  }
});

const loadWebhooksSuccess = (state, action) => ({
  ...state,
  webhooks: {
    loading: false,
    url: action.url
  }
});

const resetWebhooks = (state, action) => ({
  ...state,
  webhooks: INITIAL_STATE.webhooks
});

const saveWebhook = (state, action) => ({
  ...state,
  webhooks: {
    ...state.webhooks,
    loading: true
  }
});

const saveWebhookSuccess = (state, action) => ({
  ...state,
  webhooks: {
    ...state.webhooks,
    loading: false
  }
});

const loadTokensSuccess = (state, action) => ({
  ...state,
  tokens: {
    loading: false,
    data: action.data
  }
});

const addToken = (state, action) => ({
  ...state,
  tokens: {
    ...state.tokens,
    adding: true
  }
});

const addTokenSuccess = (state, action) => ({
  ...state,
  tokens: {
    ...state.tokens,
    adding: false
  }
});

const resetTokens = (state, action) => ({
  ...state,
  tokens: INITIAL_STATE.tokens
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_WEBHOOKS]: resetWebhooks,
  [Types.LOAD_WEBHOOKS_SUCCESS]: loadWebhooksSuccess,
  [Types.RESET_WEBHOOKS]: resetWebhooks,
  [Types.SAVE_WEBHOOK]: saveWebhook,
  [Types.SAVE_WEBHOOK_SUCCESS]: saveWebhookSuccess,
  [Types.LOAD_TOKENS]: resetTokens,
  [Types.LOAD_TOKENS_SUCCESS]: loadTokensSuccess,
  [Types.RESET_TOKENS]: resetTokens,
  [Types.ADD_TOKEN]: addToken,
  [Types.ADD_TOKEN_SUCCESS]: addTokenSuccess
});
